<template lang="pug">
  .high-lift-chart.container
    .row
      .title-wrap.xs-12.text-center
        .fixed-width-tweak-upper
          h2.upper.semi-bold.xs-f-large.md-f-xlarge.lg-f-large.max-at-tweak {{titleH2}}
          p.xs-f-small.md-f-medium.lg-f-small.max-at-tweak {{text}}
      
      .xs-12.chart-wrap.xs-f-small
        .xs-12
          .a-box-xs-1x1.a-box-sm-4x5.chart(:class="containerClass")
            .a-box-content
              ImgBox(:mediaObj="image")
        
        p.start-text.upper.semi-bold.xs-f-small.sm-f-medium.md-f-large.lg-f-xmedium.max-at-tweak If you're starting here...
        
        p.ferrara-text.upper.xs-f-small.sm-f-medium.md-f-large.lg-f-xmedium.max-at-tweak
          | Your&nbsp;
          a.semi-bold(href="/product/ferrara-golden") ferrara golden&nbsp;
          | results
        
        p.anacona-text.upper.xs-f-small.sm-f-medium.md-f-large.lg-f-xmedium.max-at-tweak
          | Your&nbsp;
          a.semi-bold(href="/product/ancona-natural") anacona natural&nbsp;
          | results
        
        p.prato-text.upper.xs-f-small.sm-f-medium.md-f-large.lg-f-xmedium.max-at-tweak
          | Your&nbsp;
          a.semi-bold(href="/product/prato-ash") prato ash&nbsp;
          | results
          
        .left-nav.sm-hide.md-hide.lg-hide(@click="prev")
          span.clickable.icon-caret-left.xs-f-large.md-f-xlarge.lg-f-large.max-at-tweak
            span.ada-tooltip caret left icon

        .right-nav.sm-hide.md-hide.lg-hide(@click="next")
          span.clickable.icon-caret-right.xs-f-large.md-f-xlarge.lg-f-large.max-at-tweak
            span.ada-tooltip caret right icon
</template>

<script>
  import ImgBox from '@components/imgBox';

  export default {

    name: 'HighLiftChart',

    components: {
      ImgBox,
    },

    props: {
      titleH2: {
        type: String,
        required: true,
      },

      text: {
        type: String,
        required: true,
      },

      image: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      position: 2,
    }),

    computed: {
      containerClass() {
        return { 1: 'one', 2: 'two', 3: 'three'}[this.position];
      },
    },

    methods: {
      prev() {
        this.position = Math.max(this.position - 1, 1);
      },

      next() {
        this.position = Math.min(this.position + 1, 3);
      },
    },
  };
</script>

<style lang="stylus">
  .high-lift-chart
    .chart-wrap
      position relative
      
      .start-text
      .ferrara-text
      .anacona-text
      .prato-text
        position absolute
        width 100%
        text-align center
    
    @media mq-mobile
      .title-wrap
        h2
          padding-top 1em
          
        p
          padding 0.5em 5%
          padding-bottom 1em
          
      .chart-wrap
        overflow hidden
        padding-top 2em
        
        .chart
          width 200%
          transition(margin-left 500ms ease-in-out)
          
          &.one
            margin-left 3em
            
          &.two
            margin-left -11.4em
            
          &.three
            margin-left -26em
            
        .start-text
          top 2%
          
        .ferrara-text
          top 26.5%
          
        .anacona-text
          top 50.5%
          
        .prato-text
          top 75%
        
      .left-nav
      .right-nav
        position absolute
        width 3em
        height 100%
        top 0
        
        .icon-caret-left
        .icon-caret-right
          position absolute
          top 0.3em
        
      .left-nav
        left 0
        
        .icon-caret-left
          left 0.5em
        
      .right-nav
        right 0
        
        .icon-caret-right
          right 0.5em
    
    @media mq-tablet
      .title-wrap
        h2
          padding-top 1.5em
        
        p
          padding 0.5em 22%
          padding-bottom 1em
          
      .chart-wrap
        .start-text
          top 0
          
        .ferrara-text
          top 24.5%
          
        .anacona-text
          top 49%
          
        .prato-text
          top 74%
          
    @media mq-desktop-md
      .title-wrap
        h2
          padding-top 1.5em
        
        p
          padding 0.5em 26%
          padding-bottom 1em
          
      .chart-wrap
        padding-top 2em
            
        .start-text
          top 2%
          
        .ferrara-text
          top 26.5%
          
        .anacona-text
          top 50.5%
          
        .prato-text
          top 75%
          
    @media mq-desktop-plus
      .title-wrap
        h2
          padding-top 1.5em
        
        p
          padding 0.5em 10%
          padding-bottom 1.5em
          
      .chart-wrap
        padding 0 20%

        .start-text
        .ferrara-text
        .anacona-text
        .prato-text
          width 60%
            
        .start-text
          top 0%
          
        .ferrara-text
          top 24.5%
          
        .anacona-text
          top 49%
          
        .prato-text
          top 74%
</style>